import { fdate } from './helpers';
import { FRONT_DF_2, FRONT_MF } from '../CONST';

export const objectToOption = (object, labelField, index=null) => ({
  label: object[labelField],
  value: object,
  index,
});

export const objectToOptionForMultiSelect = (object, labelField) => ({
  label: object[labelField],
  value: object.id,
  object,
});

export const objectsToOptions = (objects, labelField, isMultiSelect = false) => {
  if (isMultiSelect) {
    return objects.map(obj => (objectToOptionForMultiSelect(obj, labelField)));
  }
  return objects.map((obj, index) => (objectToOption(obj, labelField, index)));
};

export const findSelectedOption = (options, objId, fullObj = false) => (
  objId ? options.find((opt) => (fullObj ? opt.value.id === objId : opt.value === objId)) : null
);


export const clientToOption = client => {
  if (client) {
    return {
      label: `${client.rut} - ${client.nombre}`,
      value: client,
    };
  }
  return null;
};

export const vigenciasToOptions = endososVigencia => endososVigencia.map((endoso, index) => ({
  label: `#${endoso.numero_vigencia}: del ${fdate(endoso.inicio_vigencia, FRONT_DF_2)} al ${fdate(endoso.termino_vigencia, FRONT_DF_2)}`,
  value: endoso,
  index,
}));

export const tiposDeudorToOptions = (tiposDeudor) => tiposDeudor.map(tipoDeudor => ({
  label: tipoDeudor.descripcion,
  value: tipoDeudor
}));

export const tiposDeudorToFilterOptions = (tiposDeudor) => tiposDeudor.map(tipoDeudor => ({
  label: tipoDeudor.descripcion,
  value: tipoDeudor.descripcion
}));

export const enumModelToFilterOptions = (models) => models.map(model => ({
  label: model.descripcion,
  value: model.id
}));

export const libroVentasToOption = (dte) => {
  if (!dte || !dte.libro_venta) {
    return null
  }
  return {
    label: fdate(dte.libro_venta.periodo, FRONT_MF),
    value: dte.libro_venta.id
  }
}

export const librosVentasToOptions = (dtes) => (
  dtes.reduce((librosVentasOps, dte) => (
    librosVentasOps.some((option) => option.value === dte.libro_venta.id)
      ? librosVentasOps
      : [...librosVentasOps, libroVentasToOption(dte)]
  ), [])
);

export const deudorToOption = (dte) => {
  if (!dte || !dte.deudor) {
    return null
  }
  return {
    label: `${dte.deudor.rut} - ${dte.deudor.nombre}`,
    value: dte.deudor.rut
  }
}

export const deudoresToOptions = (dtes) => (
  dtes.reduce((deudoresOpts, dte) => (
    deudoresOpts.some((option) => option.value === dte.deudor.rut)
      ? deudoresOpts
      : [...deudoresOpts, deudorToOption(dte)]
  ), [])
);

export const foliosToOptions = (dtes) => (
  dtes.map((dte) => ({
    label: dte.numero_documento,
    value: dte
  }))
);

export const objectsToFilterOptions = (objects) =>
  objects.map((object) => ({
    label: object.descripcion,
    value: object.descripcion,
  }));
